<template>
  <div>
    <div class="products">
      <div class="container">
        <el-table
          :data="pagedTableData"
          stripe
          :border="true"
          style="width: 95%">
          <el-table-column
            prop="name"
            align="center"
            resizable
            label="Nom"
            sortable>
          </el-table-column>
          <el-table-column
            prop="supplier"
            resizable
            align="center"
            label="Fournisseur"
            column-key="supplier">
          </el-table-column>
          <el-table-column
            v-if="shouldDisplayUc"
            prop="uc"
            align="center"
            resizable
            label="Unité de commande">
          </el-table-column>
          <el-table-column
            v-if="settings.shouldDisplayPrice"
            prop="price"
            align="center"
            resizable
            label="Prix">
          </el-table-column>
          <el-table-column
            prop="tag"
            resizable
            align="center"
            label="Catégorie">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.tag.name" type="success">
                {{scope.row.tag.name}}
              </el-tag>
              <el-tag v-if="!scope.row.tag" type="danger">
                Pas de catégorie
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            resizable
            prop="quantity"
            label="Quantité">
            <template slot-scope="scope">
              <div class="products--item--quantity">
                <el-button type=""
                           icon="el-icon-minus"
                           class="margin-left el-button"
                           @click="rmvQuantity(scope.row)"
                           size="small"
                           circle></el-button>
                <p class="margin-left">{{itemQuantity(scope.row)}}</p>
                <el-button type=""
                           class="el-button"
                           icon="el-icon-plus"
                           @click="addQuantity(scope.row)"
                           size="small"
                           circle></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next"
                       :total="this.filteredTableData.length"
                       @current-change="setPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  // eslint-disable-next-line import/extensions
  import { basicUtils } from '../../utils/utils.js';

  export default {
    components: {},
    data() {
      return {
        page: 1,
        pageSize: 10,
      };
    },
    props: {
      filters: {},
      loading: Boolean,
      products: {},
    },
    computed: {
      settings() {
        return this.$store.getters['settings/settings'];
      },
      shouldDisplayUc() {
        return this.$mq.above(768);
      },
      cart() {
        return this.$store.getters['cart/cart'];
      },
      pagedTableData() {
        return this
          .filteredTableData
          .slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
      },
      filteredTableData() {
        if (this.filters.autocomplete !== '') {
          return this.products.filter((item) => item.name.toLowerCase()
            .indexOf(this.filters.autocomplete.toLowerCase()) > -1);
        }
        if (this.filters.supplier !== null) {
          return basicUtils.filter(this.products, 'supplier', this.filters.supplier);
        }
        if (this.filters.tag !== null) {
          return basicUtils.filter(this.products, 'tag', this.filters.tag);
        }
        return this.products;
      },
    },
    methods: {
      itemQuantity(product) {
        const quantity = this.$store.getters['cart/cart'].find((item) => item.id === product.id);
        return quantity ? quantity.quantity : 0;
      },
      num(index) {
        return this.itemQuantity(index);
      },
      addQuantity(product) {
        this.$store.dispatch('cart/addToCart', product);
      },
      rmvQuantity(product) {
        this.$store.dispatch('cart/removeOneFromCart', product);
      },
      changeQuantityNumber(product, quantityAdded) {
        const payload = {
          quantityAdded,
          product,
        };
        this.$store.dispatch('cart/addGivenQuantityOfAProduct', payload);
      },
      setPage(val) {
        this.page = val;
      },
    },
  };

</script>

<style lang="stylus">
  @import '~@/assets/css/main.styl';

  .products--item--quantity {
    display flex
    flex-direction row
    align-items center
    justify-content center
  }

  .margin-left {
    margin-right 15px
  }

  .el-button {
    background-color $secondary-color
    color $light-color
    border none
  }

</style>
